import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Testbed} from "../../../model/testbed";
import { Company } from 'src/app/model/company';

class DataForTestbedCreation {
  testbed: Testbed = new Testbed();
  creatingFromContract?: boolean;
  company?: Company;
}

@Component({
  selector: 'aw-create-testbed',
  templateUrl: './create-testbed-dialog.component.html',
  styleUrls: ['./create-testbed-dialog.component.scss']
})
export class CreateTestbedDialogComponent implements OnInit {

  embeddedLayout = false;
  creatingFromContract = false;
  returnThisInDialogClose?: boolean | Testbed;

  constructor(
    public dialogRef: MatDialogRef<CreateTestbedDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DataForTestbedCreation,
  ) {
  }

  ngOnInit(): void {

    if (this.data.creatingFromContract) {
      this.creatingFromContract = this.data.creatingFromContract;
      this.returnThisInDialogClose = true;
    }
  }


  returnTestbed(event: Testbed): void {
    this.returnThisInDialogClose = event;
  }
}


